import { Alert, Heading } from "@icg360/design-system";

import { MSSLink } from "components/common/link";
import { Stack } from "components/common/stack";

import styles from "./ceremony-error-section.module.scss";

export const CeremonyErrorSection = () => (
  <div className={styles.wrapper}>
    <Stack>
      <Heading size="md">Existing SageSure account</Heading>
      <Alert
        appearance="warning"
        title=""
        description="It looks like our system is experiencing a problem right now. Please try linking your GEICO account again later."
      />
      <MSSLink to="/">Visit SageSure to access your account.</MSSLink>
    </Stack>
  </div>
);
